/* unplugin-vue-components disabled */import script from "./cultural-banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./cultural-banner.vue?vue&type=script&setup=true&lang=ts"

import "./cultural-banner.vue?vue&type=style&index=0&id=070ac1f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070ac1f2"]])

export default __exports__